import { FileQuestion } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { Card } from "@/components/ui/Card";
import { EmptyState } from "@/components/ui/EmptyState";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <Card className="mx-auto mt-10 max-w-xl">
      <EmptyState icon={FileQuestion} title={t("notFound.title")}>
        <p>{t("notFound.body")}</p>
        <Link
          to="/"
          className="mt-4 inline-flex h-control items-center rounded-control bg-primary px-4 text-sm font-medium text-on-primary hover:bg-primary-hover"
        >
          {t("notFound.back")}
        </Link>
      </EmptyState>
    </Card>
  );
}
